export function Help() {
	return (
	  <div className="App-Help">
<p>Voici la liste des mots que vous pouvez avoir à deviner :</p>
<h1 id="4-lettres">4 lettres</h1>
<ul>
<li>acte</li>
<li>aura</li>
<li>beau</li>
<li>bien</li>
<li>care</li>
<li>cire</li>
<li>cité</li>
<li>dieu</li>
<li>doxa</li>
<li>éros</li>
<li>état</li>
<li>être</li>
<li>fait</li>
<li>goût</li>
<li>hylè</li>
<li>idée</li>
<li>inné</li>
<li>joie</li>
<li>lois</li>
<li>luxe</li>
<li>même</li>
<li>mode</li>
<li>mort</li>
<li>noûs</li>
<li>paix</li>
<li>pari</li>
<li>réel</li>
<li>rêve</li>
<li>sage</li>
<li>sens</li>
<li>sexe</li>
<li>tout</li>
<li>vain</li>
<li>vécu</li>
<li>vice</li>
<li>vrai</li>
</ul>
<h1 id="5-lettres">5 lettres</h1>
<ul>
<li>agapè</li>
<li>agent</li>
<li>amour</li>
<li>archè</li>
<li>atome</li>
<li>autre</li>
<li>cause</li>
<li>chair</li>
<li>champ</li>
<li>chaos</li>
<li>chose</li>
<li>corps</li>
<li>crâne</li>
<li>désir</li>
<li>dogme</li>
<li>donné</li>
<li>doute</li>
<li>droit</li>
<li>drone</li>
<li>durée</li>
<li>eidos</li>
<li>envie</li>
<li>étant</li>
<li>ethos</li>
<li>fatum</li>
<li>faute</li>
<li>folie</li>
<li>force</li>
<li>forme</li>
<li>fossé</li>
<li>foule</li>
<li>futur</li>
<li>génie</li>
<li>genre</li>
<li>gnose</li>
<li>grâce</li>
<li>icône</li>
<li>idéal</li>
<li>idole</li>
<li>image</li>
<li>lâche</li>
<li>légal</li>
<li>logos</li>
<li>magie</li>
<li>monde</li>
<li>moral</li>
<li>motif</li>
<li>moyen</li>
<li>mythe</li>
<li>néant</li>
<li>noème</li>
<li>nomos</li>
<li>norme</li>
<li>objet</li>
<li>ordre</li>
<li>oubli</li>
<li>ousia</li>
<li>outil</li>
<li>pacte</li>
<li>passé</li>
<li>pitié</li>
<li>polis</li>
<li>privé</li>
<li>règle</li>
<li>sacré</li>
<li>salut</li>
<li>santé</li>
<li>signe</li>
<li>sujet</li>
<li>telos</li>
<li>temps</li>
<li>thèse</li>
<li>trope</li>
<li>unité</li>
<li>usage</li>
<li>utile</li>
<li>vertu</li>
<li>virtù</li>
</ul>
<h1 id="6-lettres">6 lettres</h1>
<ul>
<li>absolu</li>
<li>acédie</li>
<li>acquis</li>
<li>action</li>
<li>affect</li>
<li>aliéné</li>
<li>amitié</li>
<li>anankè</li>
<li>animal</li>
<li>anomie</li>
<li>aponie</li>
<li>aporie</li>
<li>aséité</li>
<li>autrui</li>
<li>avenir</li>
<li>axiome</li>
<li>beauté</li>
<li>besoin</li>
<li>bêtise</li>
<li>cinéma</li>
<li>cogito</li>
<li>cosmos</li>
<li>croire</li>
<li>dasein</li>
<li>déisme</li>
<li>destin</li>
<li>devoir</li>
<li>entité</li>
<li>épochè</li>
<li>équité</li>
<li>erreur</li>
<li>espace</li>
<li>espèce</li>
<li>esprit</li>
<li>extase</li>
<li>fictif</li>
<li>formel</li>
<li>genèse</li>
<li>guerre</li>
<li>hasard</li>
<li>hubris</li>
<li>hybris</li>
<li>infini</li>
<li>ironie</li>
<li>kairos</li>
<li>langue</li>
<li>libido</li>
<li>limite</li>
<li>manque</li>
<li>maxime</li>
<li>médiat</li>
<li>mépris</li>
<li>mérite</li>
<li>mesure</li>
<li>mobile</li>
<li>modèle</li>
<li>moeurs</li>
<li>monade</li>
<li>morale</li>
<li>mortel</li>
<li>moteur</li>
<li>nature</li>
<li>nombre</li>
<li>normal</li>
<li>notion</li>
<li>pardon</li>
<li>parole</li>
<li>pathos</li>
<li>pensée</li>
<li>penser</li>
<li>peuple</li>
<li>philia</li>
<li>phusis</li>
<li>physis</li>
<li>praxis</li>
<li>preuve</li>
<li>public</li>
<li>qualia</li>
<li>raison</li>
<li>règles</li>
<li>salaud</li>
<li>savoir</li>
<li>schème</li>
<li>signal</li>
<li>simple</li>
<li>social</li>
<li>sophia</li>
<li>sorite</li>
<li>surmoi</li>
<li>talent</li>
<li>utopie</li>
<li>valeur</li>
<li>vanité</li>
<li>vérité</li>
<li>visage</li>
<li>vivant</li>
<li>zombie</li>
</ul>
<h1 id="7-lettres">7 lettres</h1>
<ul>
<li>aboulie</li>
<li>absurde</li>
<li>acrasie</li>
<li>agnosie</li>
<li>analyse</li>
<li>animaux</li>
<li>apathie</li>
<li>appétit</li>
<li>apriori</li>
<li>bonheur</li>
<li>capital</li>
<li>caverne</li>
<li>certain</li>
<li>cerveau</li>
<li>citoyen</li>
<li>conatus</li>
<li>concept</li>
<li>concret</li>
<li>conflit</li>
<li>contrat</li>
<li>courage</li>
<li>critère</li>
<li>culture</li>
<li>cynisme</li>
<li>despote</li>
<li>devenir</li>
<li>dignité</li>
<li>dilemme</li>
<li>eccéité</li>
<li>échange</li>
<li>écocide</li>
<li>égalité</li>
<li>éléates</li>
<li>émotion</li>
<li>empirie</li>
<li>enfance</li>
<li>esclave</li>
<li>essence</li>
<li>étendue</li>
<li>éthique</li>
<li>exemple</li>
<li>factuel</li>
<li>faculté</li>
<li>fiction</li>
<li>fortune</li>
<li>général</li>
<li>gestalt</li>
<li>habitus</li>
<li>holisme</li>
<li>horizon</li>
<li>horreur</li>
<li>immoral</li>
<li>intérêt</li>
<li>ipséité</li>
<li>justice</li>
<li>kantien</li>
<li>laïcité</li>
<li>langage</li>
<li>liberté</li>
<li>licence</li>
<li>logique</li>
<li>machine</li>
<li>maladie</li>
<li>matière</li>
<li>maximes</li>
<li>méchant</li>
<li>mémoire</li>
<li>méthode</li>
<li>mimèsis</li>
<li>miracle</li>
<li>mobiles</li>
<li>monisme</li>
<li>motrice</li>
<li>mystère</li>
<li>naturel</li>
<li>négatif</li>
<li>névrose</li>
<li>noumène</li>
<li>ontique</li>
<li>opinion</li>
<li>organon</li>
<li>origine</li>
<li>passion</li>
<li>penseur</li>
<li>persona</li>
<li>plaisir</li>
<li>positif</li>
<li>pouvoir</li>
<li>préjugé</li>
<li>présent</li>
<li>profane</li>
<li>progrès</li>
<li>pulsion</li>
<li>qualité</li>
<li>racisme</li>
<li>réalité</li>
<li>réifier</li>
<li>relatif</li>
<li>respect</li>
<li>sadisme</li>
<li>sagesse</li>
<li>science</li>
<li>société</li>
<li>stoïque</li>
<li>sublime</li>
<li>symbole</li>
<li>système</li>
<li>théisme</li>
<li>théiste</li>
<li>théorie</li>
<li>topique</li>
<li>travail</li>
<li>univers</li>
<li>utilité</li>
<li>virtuel</li>
<li>visible</li>
<li>volonté</li>
<li>zombies</li>
</ul>
<h1 id="8-lettres">8 lettres</h1>
<ul>
<li>abstrait</li>
<li>accident</li>
<li>agréable</li>
<li>alètheia</li>
<li>altérité</li>
<li>analogie</li>
<li>anarchie</li>
<li>angoisse</li>
<li>argument</li>
<li>ataraxie</li>
<li>athéisme</li>
<li>atomisme</li>
<li>attribut</li>
<li>autorité</li>
<li>barbarie</li>
<li>civilisé</li>
<li>clinamen</li>
<li>cognitif</li>
<li>création</li>
<li>critique</li>
<li>croyance</li>
<li>culturel</li>
<li>cyniques</li>
<li>démesure</li>
<li>démiurge</li>
<li>diallèle</li>
<li>dialogue</li>
<li>discours</li>
<li>doctrine</li>
<li>donation</li>
<li>dualisme</li>
<li>écologie</li>
<li>économie</li>
<li>émotions</li>
<li>empathie</li>
<li>energeia</li>
<li>épistémè</li>
<li>éternité</li>
<li>évidence</li>
<li>fatalité</li>
<li>fidéisme</li>
<li>finalisé</li>
<li>finalité</li>
<li>finitude</li>
<li>génocide</li>
<li>grégaire</li>
<li>habitude</li>
<li>harmonie</li>
<li>heccéité</li>
<li>hegélien</li>
<li>histoire</li>
<li>humanité</li>
<li>idéalité</li>
<li>identité</li>
<li>illusion</li>
<li>immanent</li>
<li>immédiat</li>
<li>individu</li>
<li>inhérent</li>
<li>inhumain</li>
<li>innéisme</li>
<li>instinct</li>
<li>intrigue</li>
<li>intuitif</li>
<li>ironique</li>
<li>jugement</li>
<li>kantisme</li>
<li>légalité</li>
<li>légitime</li>
<li>libertin</li>
<li>lumières</li>
<li>majorité</li>
<li>marxisme</li>
<li>matériel</li>
<li>mathesis</li>
<li>mensonge</li>
<li>minorité</li>
<li>miracles</li>
<li>modalité</li>
<li>moralité</li>
<li>mystique</li>
<li>normatif</li>
<li>numineux</li>
<li>objectif</li>
<li>paradoxe</li>
<li>passions</li>
<li>pastoral</li>
<li>penchant</li>
<li>penseuse</li>
<li>personne</li>
<li>poétique</li>
<li>possible</li>
<li>postulat</li>
<li>pratique</li>
<li>prédicat</li>
<li>prémisse</li>
<li>principe</li>
<li>probable</li>
<li>problème</li>
<li>prudence</li>
<li>psychose</li>
<li>quantité</li>
<li>question</li>
<li>quiddité</li>
<li>réalisme</li>
<li>référent</li>
<li>relation</li>
<li>religion</li>
<li>sartrien</li>
<li>sensible</li>
<li>signifié</li>
<li>sophisme</li>
<li>sophiste</li>
<li>spécisme</li>
<li>spontané</li>
<li>stoïcien</li>
<li>substrat</li>
<li>subsumer</li>
<li>surhomme</li>
<li>synthèse</li>
<li>théorème</li>
<li>thomisme</li>
<li>totalité</li>
<li>tragique</li>
<li>trilemme</li>
<li>troupeau</li>
<li>tyrannie</li>
<li>univoque</li>
<li>utopique</li>
<li>validité</li>
<li>véracité</li>
<li>violence</li>
<li>volition</li>
</ul>
<h1 id="9-lettres">9 lettres</h1>
<ul>
<li>abduction</li>
<li>affection</li>
<li>altruisme</li>
<li>anamnnèse</li>
<li>antinomie</li>
<li>antithèse</li>
<li>apparence</li>
<li>archétype</li>
<li>ascétique</li>
<li>ascétisme</li>
<li>aufhebung</li>
<li>autonomie</li>
<li>axiologie</li>
<li>béatitude</li>
<li>cartésien</li>
<li>catégorie</li>
<li>catharsis</li>
<li>causalité</li>
<li>certitude</li>
<li>civiliser</li>
<li>cognition</li>
<li>cohérence</li>
<li>consensus</li>
<li>construit</li>
<li>contraire</li>
<li>décadence</li>
<li>déduction</li>
<li>dépiction</li>
<li>discursif</li>
<li>éducation</li>
<li>eidétique</li>
<li>émergence</li>
<li>empirique</li>
<li>empirisme</li>
<li>équivoque</li>
<li>esclavage</li>
<li>espérance</li>
<li>essentiel</li>
<li>étiologie</li>
<li>événement</li>
<li>existence</li>
<li>expliquer</li>
<li>extension</li>
<li>facticité</li>
<li>fanatisme</li>
<li>fatalisme</li>
<li>féminisme</li>
<li>finalisme</li>
<li>fondement</li>
<li>freudisme</li>
<li>grammaire</li>
<li>hédonisme</li>
<li>hégémonie</li>
<li>historial</li>
<li>homologue</li>
<li>homonymie</li>
<li>humanisme</li>
<li>hypostase</li>
<li>hypothèse</li>
<li>idéalisme</li>
<li>idéalités</li>
<li>identique</li>
<li>idéologie</li>
<li>idolâtrie</li>
<li>ignorance</li>
<li>immanence</li>
<li>impératif</li>
<li>impulsion</li>
<li>induction</li>
<li>inférence</li>
<li>intellect</li>
<li>intension</li>
<li>intensité</li>
<li>intuition</li>
<li>libertins</li>
<li>mécanisme</li>
<li>mécaniste</li>
<li>mémétique</li>
<li>métaphore</li>
<li>minorités</li>
<li>modalités</li>
<li>modernité</li>
<li>monarchie</li>
<li>moralisme</li>
<li>mouvement</li>
<li>multitude</li>
<li>mystiques</li>
<li>narrative</li>
<li>nécessité</li>
<li>nihilisme</li>
<li>ontologie</li>
<li>optimisme</li>
<li>organisme</li>
<li>paradigme</li>
<li>paresseux</li>
<li>persuader</li>
<li>phénomène</li>
<li>phronesis</li>
<li>pléonexie</li>
<li>politique</li>
<li>prénotion</li>
<li>privation</li>
<li>propriété</li>
<li>psychique</li>
<li>puissance</li>
<li>quiétisme</li>
<li>rationnel</li>
<li>réduction</li>
<li>référence</li>
<li>rigorisme</li>
<li>sacrifice</li>
<li>sansation</li>
<li>sceptique</li>
<li>sentiment</li>
<li>servitude</li>
<li>simulacre</li>
<li>singulier</li>
<li>sophistes</li>
<li>souverain</li>
<li>stoïcisme</li>
<li>structure</li>
<li>subjectif</li>
<li>substance</li>
<li>sympathie</li>
<li>technique</li>
<li>théodicée</li>
<li>théorique</li>
<li>tolérance</li>
<li>tradition</li>
<li>universel</li>
<li>univocité</li>
<li>véganisme</li>
<li>vengeance</li>
<li>vitalisme</li>
<li>zététique</li>
</ul>
<h1 id="10-lettres">10 lettres</h1>
<ul>
<li>accidentel</li>
<li>agnostique</li>
<li>aliénation</li>
<li>anagogique</li>
<li>analytique</li>
<li>anarchisme</li>
<li>apollinien</li>
<li>aporétique</li>
<li>arbitraire</li>
<li>artificiel</li>
<li>bioéthique</li>
<li>biopouvoir</li>
<li>bouddhisme</li>
<li>capabilité</li>
<li>communauté</li>
<li>communisme</li>
<li>compassion</li>
<li>comprendre</li>
<li>conclusion</li>
<li>conjecture</li>
<li>conscience</li>
<li>contingent</li>
<li>contrainte</li>
<li>convaincre</li>
<li>convention</li>
<li>conviction</li>
<li>cosmologie</li>
<li>créativité</li>
<li>définition</li>
<li>démocratie</li>
<li>descriptif</li>
<li>despotisme</li>
<li>différance</li>
<li>différence</li>
<li>discipline</li>
<li>dogmatique</li>
<li>dogmatisme</li>
<li>domination</li>
<li>écologique</li>
<li>économique</li>
<li>efficiente</li>
<li>engagement</li>
<li>entéléchie</li>
<li>épicurisme</li>
<li>équivocité</li>
<li>esthétique</li>
<li>étonnement</li>
<li>euthanasie</li>
<li>expérience</li>
<li>expression</li>
<li>fétichisme</li>
<li>formalisme</li>
<li>généalogie</li>
<li>générosité</li>
<li>gnostiques</li>
<li>hiérarchie</li>
<li>imaginaire</li>
<li>immatériel</li>
<li>immoralité</li>
<li>impossible</li>
<li>inquiétude</li>
<li>isosthénie</li>
<li>jansénisme</li>
<li>légitimité</li>
<li>machinisme</li>
<li>maïeutique</li>
<li>matérielle</li>
<li>méchanceté</li>
<li>médiologie</li>
<li>mélancolie</li>
<li>méréologie</li>
<li>modération</li>
<li>modularité</li>
<li>mysticisme</li>
<li>mythologie</li>
<li>nécessaire</li>
<li>négativité</li>
<li>neutralité</li>
<li>obligation</li>
<li>oppression</li>
<li>panthéisme</li>
<li>perception</li>
<li>perfection</li>
<li>perversion</li>
<li>pessimisme</li>
<li>philosophe</li>
<li>platonisme</li>
<li>pluralisme</li>
<li>prédiction</li>
<li>providence</li>
<li>qualitatif</li>
<li>réfutation</li>
<li>régression</li>
<li>relativité</li>
<li>république</li>
<li>résistance</li>
<li>révélation</li>
<li>révolution</li>
<li>rhétorique</li>
<li>romantisme</li>
<li>scientisme</li>
<li>sémantique</li>
<li>sémiologie</li>
<li>signifiant</li>
<li>simplicité</li>
<li>simulacres</li>
<li>socialisme</li>
<li>sociologie</li>
<li>socratique</li>
<li>solidarité</li>
<li>solipsisme</li>
<li>spéculatif</li>
<li>spinozisme</li>
<li>survenance</li>
<li>syllogisme</li>
<li>symbolique</li>
<li>tautologie</li>
<li>taylorisme</li>
<li>téléologie</li>
<li>tempérance</li>
<li>théocratie</li>
<li>tyrannique</li>
<li>universaux</li>
<li>volontaire</li>
</ul>
<h1 id="11-lettres">11 lettres</h1>
<ul>
<li>abstraction</li>
<li>acatalepsie</li>
<li>aperception</li>
<li>apodictique</li>
<li>assentiment</li>
<li>autonomisme</li>
<li>axiomatique</li>
<li>capabilités</li>
<li>capitalisme</li>
<li>casuistique</li>
<li>catégorique</li>
<li>citoyenneté</li>
<li>compossible</li>
<li>conséquence</li>
<li>contingence</li>
<li>cyrénaïques</li>
<li>démarcation</li>
<li>déontologie</li>
<li>description</li>
<li>désignation</li>
<li>dévoilement</li>
<li>dialectique</li>
<li>dionysiaque</li>
<li>entendement</li>
<li>épistémique</li>
<li>eudémonisme</li>
<li>extrinsèque</li>
<li>falsifiable</li>
<li>hétéronomie</li>
<li>heuristique</li>
<li>historicité</li>
<li>hypostasier</li>
<li>idéologique</li>
<li>imagination</li>
<li>immoralisme</li>
<li>immortalité</li>
<li>implication</li>
<li>inconscient</li>
<li>inférentiel</li>
<li>institution</li>
<li>instruction</li>
<li>interpréter</li>
<li>intrinsèque</li>
<li>irrationnel</li>
<li>libéralisme</li>
<li>libertarien</li>
<li>manichéisme</li>
<li>marchandise</li>
<li>métaéthique</li>
<li>monadologie</li>
<li>monothéisme</li>
<li>mythologies</li>
<li>naturaliser</li>
<li>naturalisme</li>
<li>nietzschéen</li>
<li>nominalisme</li>
<li>normativité</li>
<li>objectivité</li>
<li>observation</li>
<li>omnipotence</li>
<li>omniscience</li>
<li>ontologique</li>
<li>organicisme</li>
<li>paralogisme</li>
<li>particulier</li>
<li>performatif</li>
<li>philosophie</li>
<li>positivisme</li>
<li>possibilité</li>
<li>pragmatique</li>
<li>pragmatisme</li>
<li>préférences</li>
<li>prescriptif</li>
<li>probabilité</li>
<li>prohairesis</li>
<li>prolétariat</li>
<li>proposition</li>
<li>psychologie</li>
<li>quantitatif</li>
<li>raisonnable</li>
<li>rationalité</li>
<li>refoulement</li>
<li>réification</li>
<li>relativisme</li>
<li>scepticisme</li>
<li>schématisme</li>
<li>scolastique</li>
<li>sensibilité</li>
<li>sociabilité</li>
<li>sophistique</li>
<li>spéculation</li>
<li>spontanéité</li>
<li>sublimation</li>
<li>subsomption</li>
<li>substantiel</li>
<li>sursomption</li>
<li>synthétique</li>
<li>technologie</li>
<li>temporalité</li>
<li>théologique</li>
<li>théorétique</li>
<li>vérifacteur</li>
</ul>
	</div>  
	)
}